import { post } from '../apiRequest';

export const contractsExcelExport = {
  getFiltered: (params: { query: string; variables: any }) => {
    return post(`v1/Contracts/filteredContractsExcelExport`, params);
  },
};
